/* Core & libraries */
import React from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";
import Container from "react-bootstrap/Container";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

/* Helpers, constants, custom methods, internal libraries */
/* Components */
/* Styles */
import styles from "./styles.js"


const ReportsPageHeader = () => {
  const theme = useTheme();
  const classes = styles({ theme });

  return (
    <div className={classes.peoplePageHeader}>
      <Container className={classes.container}>
        <Row>
          <Col xs={12} sm={12} md={12} lg={12} className="gx-0">
            <h1 className={classes.title}><FormattedMessage id="reports.title" /></h1>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default ReportsPageHeader;
